import {
  HttpClient,
  setSSOFunctions,
  setOnMaxRetriesExhausted,
} from '@pfizer/shared/http';
import { getAPIBaseURL } from '@pfizer/shared/config';

// Re-export for backward compatibility
export { setSSOFunctions, setOnMaxRetriesExhausted };

// Re-export types for backward compatibility
export type {
  HttpClientRequestPayload as HTTPClientRequestPayload,
  HttpClientRequestHeaders as HTTPClientRequestHeaders,
} from '@pfizer/shared/http';

// For backward compatibility with existing code that expects AxiosResponse
export type HTTPClientResponse = unknown;

// Create and export singleton instance with environment-specific base URL
export const httpClient = new HttpClient({
  baseURL: getAPIBaseURL(),
});
